import React, { useEffect, useState } from "react";
import "./StatusCard.css";

const StatusCard = ({
  business,
  saving,
  onSave,
}) => {

  const [status, setStatus] = useState("Open");

  useEffect(() => {
    if (business) {
      setStatus(business.businessStatus || "Open");
    }
  }, [business]);

  const submit = () => {
    onSave({
      businessStatus: status,
    });
  };

  const getStatusClass = () => {
    switch (status) {
      case "Open":
        return "open";
      case "Busy":
        return "busy";
      case "Closed":
        return "closed";
      default:
        return "open";
    }
  };

  return (
    <div className="status-card">

      <div className="status-header">

        <div>
          <h3>🏪 Business Status</h3>
          <p>
            Control whether customers can place new orders.
          </p>
        </div>

        <span className={`status-badge ${getStatusClass()}`}>
          {status}
        </span>

      </div>

      <div className="status-content">

        <label>Current Status</label>

        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="Open">
            🟢 Open
          </option>

          <option value="Busy">
            🟡 Busy
          </option>

          <option value="Closed">
            🔴 Closed
          </option>
        </select>

        <div className="status-note">
          💡 Customers can only place new orders when your business is marked as <strong>Open</strong>.
        </div>

        <button
          className="status-btn"
          disabled={saving}
          onClick={submit}
        >
          {saving ? "Saving..." : "Update Status"}
        </button>

      </div>

    </div>
  );
};

export default StatusCard;